import React from 'react';
import Button from '@material-ui/core/Button';
import {GRANITE_6} from '../../../../colors';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import RoomIcon from '@material-ui/icons/Room';
import theme from '../../../../theme';
import {AVATAR_WIDTH} from '../../LayerListItem';

// eslint-disable-next-line prefer-arrow-callback
export default React.forwardRef(function OverlaysSidebarButton(
    {onSidebarChange}: {onSidebarChange: (sidebar: MapSidebar) => void},
    ref: React.Ref<HTMLButtonElement>,
) {
    return (
        <Button
            onClick={() => { onSidebarChange({type: 'overlays'}); }}
            style={{padding: 0, borderRadius: 0}}
            fullWidth
            ref={ref}
        >
            <ListItem ContainerProps={{style: {width: '100%'}}}>
                <ListItemIcon style={{minWidth: AVATAR_WIDTH, justifyContent: 'center'}}>
                    <RoomIcon style={{color: theme.palette.primary.main, fontSize: 24}} />
                </ListItemIcon>
                <ListItemText
                    style={{paddingLeft: theme.spacing(1)}}
                    primary='Map Overlays'
                    secondary='My Data, Labels, and Grids'
                />
                <ListItemSecondaryAction onClick={() => { onSidebarChange({type: 'overlays'}); }}>
                    <ChevronRightIcon style={{display: 'block', color: GRANITE_6, fontSize: 24}} />
                </ListItemSecondaryAction>
            </ListItem>
        </Button>
    );
});
